import { Button, Spinner, Icon } from '@chakra-ui/react';
import { FiLock, FiAlertTriangle } from 'react-icons/fi';

interface MarketCredentialsButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  hasCredentialErrors?: boolean;
  disabled?: boolean;
}

export const MarketCredentialsButton = ({
  onClick,
  isLoading = false,
  hasCredentialErrors = false,
  disabled = false,
}: MarketCredentialsButtonProps) => {
  const baseStyles = hasCredentialErrors
    ? { color: 'black', borderColor: 'yellow.400', background: 'yellow.400' }
    : { color: 'white', borderColor: 'blue.700', background: 'blue.700' };

  return (
    <Button
      _hover={
        hasCredentialErrors
          ? { background: 'yellow.500' }
          : { color: 'blue.700', background: 'gray.200' }
      }
      variant="solid"
      size="sm"
      width="100%"
      height="60px"
      onClick={onClick}
      isDisabled={disabled || isLoading}
      leftIcon={
        isLoading ? (
          <Spinner size="xs" />
        ) : hasCredentialErrors ? (
          <Icon as={FiAlertTriangle} />
        ) : (
          <Icon as={FiLock} />
        )
      }
      {...baseStyles}
    >
      Market Credentials
    </Button>
  );
};
